import { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import CoachDrawer from './CoachDrawer';
import CommandPalette from './CommandPalette';
import QuickAdd from './QuickAdd';
import ShareAndShortcuts from './ShareAndShortcuts';
import ShortcutsHelp from './ShortcutsHelp';
import KeyboardNav from './KeyboardNav';
import SaveIndicator from './SaveIndicator';
import { bootstrapAreasFromServer } from '../../lib/areaColors';
import { useAuth } from '../../lib/auth';

/**
 * Wrapper layout: sidebar a sinistra + contenuto principale.
 * Da usare su tutte le pagine TRANNE Stampa e Login.
 *
 * Esempio:
 *   <AppLayout>
 *     <Dashboard />
 *   </AppLayout>
 */
export default function AppLayout({ children }) {
  const [coachOpen, setCoachOpen] = useState(false);
  const { session } = useAuth() || {};

  // Sync aree dal server quando l'utente è loggato (una sola volta per sessione).
  useEffect(() => {
    if (session?.access_token) {
      bootstrapAreasFromServer();
    }
  }, [session?.access_token]);

  return (
    <div className="min-h-screen flex bg-canvas">
      <Sidebar onOpenCoach={() => setCoachOpen(true)} />
      {/* pt-14 sotto lg: riserva la fascia del bottone hamburger fixed (Sidebar),
          così nessuna pagina deve più aggiungere padding ad hoc */}
      <main className="flex-1 min-w-0 pt-14 lg:pt-0" data-testid="app-main">
        {children}
      </main>
      <CoachDrawer open={coachOpen} onClose={() => setCoachOpen(false)} />
      <CommandPalette />
      <QuickAdd />
      <ShareAndShortcuts />
      <ShortcutsHelp />
      <KeyboardNav />
      <SaveIndicator />
    </div>
  );
}
